import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faBookOpen,
  faNewspaper,
  faMask,
  faDesktop,
  faMartiniGlass
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../state/Store';
import { ToggleMenu } from '../../layout/actions/Layout.actions';

export const AshMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/ash-echoes/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/ash-echoes/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Characters</span>
        </Nav.Link>
      </Link>
      <Link to="/ash-echoes/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <Link to="/ash-echoes/memory-traces">
        <Nav.Link as="span" eventKey="memory-traces" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faMask} width="18" />{' '}
          <span>Memory Traces</span>
        </Nav.Link>
      </Link>
      <Link to="/ash-echoes/tea-time">
        <Nav.Link as="span" eventKey="tea-time" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faMartiniGlass} width="18" />{' '}
          <span>Tea Time</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/ash-echoes/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/ash-echoes/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
      <hr />
      <Link to="/ash-echoes/play-on-pc">
        <Nav.Link
          as="span"
          className="special"
          eventKey="play-on-pc"
          onClick={handleOnClick}
        >
          <FontAwesomeIcon icon={faDesktop} width="18" />{' '}
          <span>Play on PC</span>
        </Nav.Link>
      </Link>
    </Nav>
  );
};
